define.alias("ember-cli-string-helpers/helpers/capitalize", "preview-grid/helpers/capitalize");